import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';
// import * as serviceWorker from './serviceWorker';


ReactDOM.render(<App />, document.getElementById('root'));

if(process.env.NODE_ENV === "production" && 'serviceWorker' in navigator) {
    // serviceWorker.registerServiceWorker();
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
        for(let registration of registrations) {
            registration.unregister()
        } })
}
